import { Suspense, useEffect, useRef } from 'react';
import { graphql, type PreloadedQuery, usePreloadedQuery, useQueryLoader } from 'react-relay';
import { useModelerContext } from '../context/useModelerContext';
import type { SpSubSitesProviderQuery } from './__generated__/SpSubSitesProviderQuery.graphql';

// @ts-ignore
export const SpSubSitesProvider = (siteUrl) => {
    const eventBus = useModelerContext().get('eventBus');
    const [queryRef, loadQuery] = useQueryLoader<SpSubSitesProviderQuery>(query);
    const queryRefRef = useRef(queryRef);
    queryRefRef.current = queryRef;

    // event listener
    useEffect(() => {
        const handler = (_event: any, siteUrl: string) => {
            eventBus.fire('spSubSitesFetched', siteUrl, {
                loading: true,
                data: undefined,
                error: undefined,
            });
            loadQuery({ siteUrl });
        };

        eventBus.on('fetchSpSubSites', handler);
        return () => {
            eventBus.off('fetchSpSubSites', handler);
        };
    }, [eventBus, loadQuery]);

    return (
        queryRef && (
            <Suspense>
                <SubSitesProvider queryRef={queryRef} />
            </Suspense>
        )
    );
};

const query = graphql`
    query SpSubSitesProviderQuery($siteUrl: String!) {
        getSharePointSubsites(siteUrl: $siteUrl) {
            url
            id
            title
        }
    }
`;

const SubSitesProvider = (props: { queryRef: PreloadedQuery<SpSubSitesProviderQuery> }) => {
    const sites = usePreloadedQuery(query, props.queryRef).getSharePointSubsites;
    const eventBus = useModelerContext().get('eventBus');

    // event dispatcher
    useEffect(() => {
        if (sites == null) {
            eventBus.fire('spSubSitesFetched', props.queryRef.variables.siteUrl, {
                loading: false,
                data: [],
                error: new Error('Subsites konnten nicht geladen werden.'),
            });
            return;
        }

        eventBus.fire('spSubSitesFetched', props.queryRef.variables.siteUrl, {
            data: !sites
                ? undefined
                : sites
                      .map((site) => ({
                          name: site.title,
                          siteUrl: site.url,
                          id: site.id,
                      }))
                      .sort((a, b) => a.name.localeCompare(b.name)),
            error: sites ? undefined : Error('Seiten konnten nicht geladen werden.'),
        });
    }, [props.queryRef]);

    return null;
};
